// removed by extract-text-webpack-plugin
module.exports = {"container":"styles__container___2vBNp","animation":"styles__animation___VArIR","links-list":"styles__links-list___1sqSK","item":"styles__item___3IYmW","line":"styles__line___2Axgg"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Home/styles.scss
// module id = 308
// module chunks = 0